import Vue from 'vue';
import VueX from 'vuex';
import { getCookie, getTimestampByRoute } from 'common/utils';

import aside from 'components/store/TravellerAside';
import orderList from './modules/orderList';
import riderList from './modules/riderList';

import * as getters from './getters';
import * as actions from './actions';
import mutations from './mutations';

Vue.use(VueX);

const logisticsCenter = getCookie('logisticsCenter');

const store = new VueX.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    aside,
    orderList,
    riderList,
  },
  getters,
  actions,
  mutations,
  state: {
    lc: logisticsCenter ? parseInt(logisticsCenter, 10) : '',
    initData: {},
    timestamp: parseInt(getTimestampByRoute(), 10),
    orderDetail: {
      open: false,
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/pages/homepage/store/index.js